module.exports = __webpack_public_path__ + "static/media/unit.ed886717.png";